<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<div class="treeNoChoose">
						<div class="selectSpot2">
							<div @click="addOrganization" style='width:92%;margin:6px 4%;border-radius:6px;padding:6px 0px;background-color:#dedede;text-align:center;'>
								<p style="cursor: pointer">
									{{$t('label_46')}}<i class="el-icon-circle-plus" style='float:right;margin-top:3px;margin-right:10px;'></i>
								</p>
							</div>
							<el-tree :load="loadChild" @node-click="nodeClick" v-if="showTree" ref="tree" :props="treeProps" :accordion='false'
							 lazy node-key="id" :default-expanded-keys="['0']" highlight-current>
								<div class="custom-tree-node" slot-scope="{node,data}">
									<div class="title" style="width:100%;position:relative;display:flex;">
										<p style="display:block;width:100%;white-space:nowrap;line-height:30px;">
											{{data.name}}
											<span class="statusBox" style="margin-left:10px;">
												<i class="el-icon-edit" @click.stop="open(data)"></i>
												<i class="el-icon-delete-solid" @click="remove(data.id)"></i>
											</span>
										</p>
									</div>
								</div>
							</el-tree>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title">{{organizationName}}</p>
						<div class="spotMes2Box" style="height: calc(100% - 56px);">
							<div class="spotMesBox" style="height:100%;">
								<el-tabs v-model="tabModel" @tab-click="tabClick">
									<el-tab-pane :label="$t('label_304')" name="organization">
										<organizationTab ref="organizationPane" @reload='reload'>
										</organizationTab>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_22')" name="role">
										<menuTab ref="menuPane">
										</menuTab>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog v-loading="saveLoading" :visible.sync="dialogVisible" :title="$t('btn_15')" :before-close="dialogClose" append-to-body v-dialogDrag
		 :close-on-click-modal='false' width="500px" top="20%" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<el-row class="dialogMes">
					<el-col :span="3" style="line-height: 40px;">{{$t('label_297')}}</el-col>
					<el-col :span="24">
						<el-input v-model="formModel.name" clearable></el-input>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<div @click="save" class="chooseButton sendButton">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import utils from '@/utils/utils'
	import organizationTab from "@/components/list/displayPage/organizationTab";
	import menuTab from "@/components/list/displayPage/menuTab";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";

	export default {
		name: 'organization',
		components: {
			organizationTab,
			menuTab,
		},
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
			  saveLoading: false,
				dialogVisible: false,
				organizationName: '',
				tabModel: 'organization',
				treeProps: {
					label: 'name',
				},
				showTree: true,
				nodeId: '',
				formModel: {
					id: '',
					name: '',
				},
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			reloadTree() {
				this.showTree = false;
				this.$nextTick(function() {
					this.showTree = true;
				})
			},
			save() {
			  this.saveLoading = true;
				this.dialogVisible = false;
				organizationTabJs.edit(this.formModel).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.dialogVisible = false;
						this.$message.success(this.$t('msg_19'));
						// utils.messageAlert(this.$t('msg_19'), this.$t('label_358'), this.$t('label_100'));
						this.formModel = {
							id: '',
							name: '',
						};
						this.reloadTree();
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})

			},
			dialogClose() {
				this.formModel = {
					id: '',
					name: "",
				};
				this.dialogVisible = false;
			},
			open(data) {
				this.dialogVisible = true;
				this.formModel.id = data.id
				this.formModel.parentId = data.parentId
				this.formModel.name = data.name
			},
			remove(id) {
				organizationTabJs.getChildren({
					pid: id,
					state: 1
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						if (data.data.length != 0) {
							utils.messageAlert(this.$t('msg_2'), this.$t('label_358'), this.$t('label_100'));
						} else {
							this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
								confirmButtonText: this.$t('label_100'),
								cancelButtonText: this.$t('btn_1'),
								type: 'warning'
							}).then(() => {
								organizationTabJs.remove({
									id: id
								}).then((response) => {
									const data = response.data;
									if (data.code == "1") {
										this.$refs.organizationPane.list();
										this.reload();
									} else {
										utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
									}
								}).catch((response) => {
									console.log(response)
								})
							}).catch(() => {});
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			reload() {
				this.showTree = false;
				this.$nextTick(function() {
					this.showTree = true;
				})
			},
			loadChild(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						if (this.nodeId == '') {
							this.organizationClick(res[0]);
						}
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			nodeClick(data, checked, resolve) {
				this.organizationClick(data);
			},
			async getChildren(pid) {
				let childArr = [];
				await organizationTabJs.getChildren({
					pid: pid,
					state: 1
				}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						childArr = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return childArr;
			},
			organizationClick(data) {
				this.$refs.organizationPane.setNodeId(data.id);
				let prefix = data.hierarchy == null ? '' : data.hierarchy.substring(0, data.level * 2);
				this.$refs.menuPane.setNodeId(data.id, prefix);
				this.organizationName = data.name;
				this.$refs.organizationPane.list();
				this.$refs.menuPane.list();
				this.nodeId = data.id;
			},
			tabClick(tab, event) {
				this.$refs.organizationPane.reloadTree();
				this.$refs.menuPane.reloadTree();
			},
			addOrganization() {
				this.$refs.organizationPane.add();
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
	}
</script>
<style scoped>
	.treeNoChoose .selectSpot2 {
		height: 100%;
	}
</style>
<style>
	.el-tabs__content {
		height: 92%;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/basic/organization.vue